export const FUNNEL_AB_PARAMETER = "&ab=variant";
